import React from 'react';
import styled from 'styled-components';

const ImgUploadBtn = styled.label`
    position:relative;
    width: 125.8px;
    height: 87px;
    display:flex;
    justify-content: center;
    align-items: center;
    border: solid 1px #dbdbdb;
    background-color: #f5f5f5;
    background-size: cover;
    background-position: center;
    box-sizing:border-box;
    cursor:pointer;
    flex-direction: column;
    font-family: 'Noto Sans KR', sans-serif;
    font-size: 11px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.27;
    letter-spacing: normal;
    text-align: center;
    color: #8d8d8d;
    text-align:center;
    ${props => props.bgUrl ? `
    background-image: url(${props.bgUrl});
    background-color: unset;
    ` : ``}
    svg{
        margin-bottom:1px;
    }
`;

const Xbtn = styled.button`
    position: absolute;
    top:1px;
    right:1px;
    opacity: 0.7;
    background-color: #000;
    border:0;
    z-index:2;
    cursor: pointer;
    &::before{
        display:block;
        padding: 3px 1.5px;
        content: "X";
        color:#fff;
    }
`;

const ImgUploadBtnWrap = styled.div`
    display:inline-block;
    position:relative;
`;

function ImageUploadButton({ fileUrl, fileCallBack, XBtnCallBack }) {
    return (
        <form>
            <ImgUploadBtnWrap>
                {fileUrl ? <Xbtn onClick={XBtnCallBack}></Xbtn> : null}
                <ImgUploadBtn htmlFor="img-upload" bgUrl={fileUrl}>
                    {fileUrl ? null :
                        <><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="#a2a2a2" className="bi bi-plus-lg" viewBox="0 0 16 16">
                            <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z" />
                        </svg>이미지 불러오기</>}
                </ImgUploadBtn>
            </ImgUploadBtnWrap>
            <input id="img-upload" type="file" style={{ display: "none" }} disabled={fileUrl ? true : false} onInput={(e) => {
                const file = e.target.files[0];
                fileCallBack(file);
            }} />
        </form>
    );
}

export default ImageUploadButton;